import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';
import { toast } from "react-hot-toast";
import { authService } from '../../Services/auth/auth.service';

export const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL
})
const nonAuthUrl = ['account-service/V3_0_0/login'];
axiosInstance.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
        if(nonAuthUrl.includes(config.url as string)) return config;
        const token = localStorage.getItem('token');
        const apiSessionStorage= localStorage.getItem('apiSessionStorage');
        if (token && config.headers) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error: AxiosError) => {
        if (error.response && error.response.status === 401) {
            window.location.href = '/';
        }
        return Promise.resolve(error);
    }
);


//response interceptor
axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error: AxiosError) => {
        const { logout } = authService.getState();
        if (error.response) {
            if (error.response.status === 401) {
                logout();
                window.location.href = '/login';
            } else {
                return Promise.resolve(error.response);
            }
        } else {
            toast.error("Network error. Please check your connection.");
        }
        return Promise.resolve(error);
    }
);